import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { AssetsDto } from './dto/open-assets-dto';
import { AssetsService } from './open-assets.service';
import { ApiTags } from '@nestjs/swagger';
import { AssetByCode } from './dto/asset-by-code';
import { AssetByStatus } from './dto/asset-by-status.dto';
import { AssetById } from './dto/asset-by-id.dto';
import { AssetRACIReport } from './dto/raci-report-dto';
import { AbstractDetails } from './dto/abstract-details-dto';
import { AssetServiceDto } from './dto/asset-service.dto';
import { AssetsId } from './dto/asset-id-req';
import { AssetsCatagoryByIdDto } from '../assets-sub-catagory/asset-catagory-id-request';
import { AssetServiceRportReq } from "libs/shared-models/asset-management/src/lib/open-assets/asset-by-status.dto";
import { UpdateRemarksDto } from './dto/remarks-update.dto';
import { UpdateChecklist } from './dto/checklist-update.dto';
import { AssetServiceReq } from '@gtpl/shared-models/common-models';
import { AssetChecklistRequestDto } from './dto/checklist-request.dto';

@ApiTags('assets')
@Controller('assets')
export class AssetsController {
    constructor(private assetsService: AssetsService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/createAssets')
    async createAssets(@Body() assetsDto: AssetsDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.create(assetsDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    // @Post('/updateassets')
    // async updatAssets(@Body() assetsDto: AssetsDto): Promise<CommonResponse> {
    //     try {
    //         return await this.assetsService.update(assetsDto);
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(CommonResponse, error);
    //     }
    // }

    @Post('/getallassets')
    async getallAssets(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAllAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAssetsForMaintainance')
    async getAllAssetsForMaintainance(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAllAssetsForMaintainance(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAssetsEligileForCheckIn')
    async getAllAssetsEligileForCheckIn(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAllAssetsEligileForCheckIn(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }


    @Post('/activeordeactive')
    async activateOrDeactivate(@Body() assetsDto: AssetsDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.activateOrDeactivate(assetsDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getByAssetCode')
    async getByAssetCode(@Body() assetId: AssetByCode): Promise<CommonResponse> {
        try {
            return await this.assetsService.getByAssetCode(assetId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getByStatus')
    async getByStatus(@Body() req: AssetByStatus): Promise<CommonResponse> {

        try {
            return await this.assetsService.getByStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/assetsCheckInMonthWiseCount')
    async assetsCheckInMonthWiseCount(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetsCheckInMonthWiseCount();

        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/assetsCount')
    async assetsCount(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetsCount();

        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }


    @Post('/assetsStatusCount')
    async assetsStatusCount(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetsStatusCount();

        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getAssetReport')
    async getAssetReport(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssetReport();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }


    @Post('/assetMonthwiseReport')
    async assetMonthwiseReport(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetMonthwiseReport();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/assetsTopWarrenty')
    async assetsTopWarrenty(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetsTopWarrenty();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/assetsTopInsurance')
    async assetsTopInsurance(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetsTopInsurance();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getRaciReport')
    async getRaciReport(@Body() req: AssetRACIReport): Promise<CommonResponse> {
        try {
            return await this.assetsService.getRaciReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }


    }

    @Post('/getAllRaciReport')
    async getAllRaciReport(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAllRaciReport();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }


    }

    @Post('/assetsDamagedCost')
    async assetsDamagedCost(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetsDamagedCost();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }


    @Post('/departmentWiseCount')
    async departmentWiseCount(): Promise<CommonResponse> {
        try {
            return await this.assetsService.departmentWiseCount();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getExpiredAssets')
    async getExpiredAssets(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getExpiredAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/assetDecommission')
    async assetDecommission(@Body() req: AssetsDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetDecommission(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/assetCodeSearch')
    async assetCodeSearch(@Body() req: AssetByCode): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetCodeSearch(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAbstractReport')
    async getAbstractReport(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAbstractReport();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getDetailsByAbstract')
    async getDetailsByAbstract(@Body() req: AbstractDetails): Promise<CommonResponse> {
        try {
            return await this.assetsService.getDetailsByAbstract(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getAssetTransactionalReport')
    async getAssetTransactionalReport(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssetTransactionalReport();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getTotalAbstract')
    async getTotalAbstract(@Body() req: AbstractDetails): Promise<CommonResponse> {
        try {
            return await this.assetsService.getTotalAbstract(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/historyReport')
    async historyReport(@Body() req: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.historyReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/createAssetService')
    async createAssetService(@Body() assetsDto: AssetServiceDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.createAssetService(assetsDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/updateAssetService')
    async updateAssetService(@Body() assetsDto: AssetServiceDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.createAssetService(assetsDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getAllAssetsDataById')
    async getAllAssetsDataById(@Body() req?: AssetsId): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAllAssetsDataById(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAsssetForCategory')
    async getAsssetForCategory(@Body() req?: AssetsCatagoryByIdDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAsssetForCategory(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getDecommissioneddAssetsReport')
    async getDecommissioneddAssetsReport(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getDecommissioneddAssetsReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getAssetServiceReportdata')
    async getAssetServiceReportdata(@Body() req?: AssetServiceRportReq): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssetServiceReportdata(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getcategorydropdown')
    async getcategorydropdown(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getcategorydropdown();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getLocationdropdown')
    async getLocationdropdown(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getLocationdropdown();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getInstockAssetCodesDropDown')
    async getInstockAssetCodesDropDown(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getInstockAssetCodesDropDown(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAssetCodesDropDown')
    async getAssetCodesDropDown(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssetCodesDropDown(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/assetHistoryInformation')
    async assetHistoryInformation(@Body() req: AssetByCode): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetHistoryInformation(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/assetsTopServices')
    async assetsTopServices(): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetsTopServices();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/updateAssetStatus')
    async updateAssetStatus(@Body() req: AssetByCode): Promise<CommonResponse> {
        try {
            return await this.assetsService.updateAssetStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getDecommissioneddAssetsReportDropdown')
    async getDecommissioneddAssetsReportDropdown(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getDecommissioneddAssetsReportDropdown(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/underMaintainanceOnInternal')
    async underMaintainanceOnInternal(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.underMaintainanceOnInternal(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/underMaintainanceOnVendor')
    async underMaintainanceOnVendor(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.underMaintainanceOnVendor(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getPlantWiseAssets')
    async getPlantWiseAssets(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getPlantWiseAssets();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getPurchasedDetailsUnused')
    async getPurchasedDetailsUnused(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getPurchasedDetailsUnused(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getpurchasedbutnotAssigned')
    async getpurchasedbutnotAssigned(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getpurchasedbutnotAssigned();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAgeWiseAssets')
    async getAgeWiseAssets(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAgeWiseAssets();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getRentedAssetCodesDropDown')
    async getRentedAssetCodesDropDown(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getRentedAssetCodesDropDown(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAssignedforRent')
    async getAssignedforRent(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssignedforRent(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getSkippedAssetsCount')
    async getSkippedAssetsCount(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getSkippedAssetsCount();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/updateServiceRemarks')
    async updateServiceRemarks(@Body() req: UpdateRemarksDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.updateServiceRemarks(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getInsuranceAssets')
    async getInsuranceAssets(@Body() req: AssetByStatus): Promise<CommonResponse> {

        try {
            return await this.assetsService.getInsuranceAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }
    @Post('getInsuranceDropDownAssets')
    async getInsuranceDropDownAssets(@Body() req: AssetByStatus): Promise<CommonResponse> {

        try {
            return await this.assetsService.getInsuranceDropDownAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }
    @Post('getWarrantyAssets')
    async getWarrantyAssets(@Body() req: AssetByStatus): Promise<CommonResponse> {

        try {
            return await this.assetsService.getWarrantyAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }
    @Post('getWarrantyDropDownAssets')
    async getWarrantyDropDownAssets(@Body() req: AssetByStatus): Promise<CommonResponse> {

        try {
            return await this.assetsService.getWarrantyDropDownAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/sendServiceRemainder')
    async sendServiceRemainder(): Promise<any> {
        try {
            return await this.assetsService.sendServiceRemainder();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getServiceDataForServiceId')
    async getServiceDataForServiceId(@Body() req: UpdateRemarksDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.getServiceDataForServiceId(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/topResponsible')
    async topResponsible(): Promise<CommonResponse> {
        try {
            return await this.assetsService.topResponsible();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getInstockAssets')
    async getInstockAssets(@Body() req: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getInstockAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getExpRents')
    async getExpRents(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getExpRents();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/assetHistory')
    async assetHistory(@Body() req: AssetByCode): Promise<CommonResponse> {
        try {
            return await this.assetsService.assetHistory(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/depreciaitionReport')
    async depreciaitionReport(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.depreciaitionReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getRentedAssetsDetails')
    async getRentedAssetsDetails():Promise<CommonResponse>{
        try{
            return await this.assetsService.getRentedAssetsDetails();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
        
    }
    
    @Post('/getAssignedforRentCatogry')
    async getAssignedforRentCatogry(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssignedforRentCatogry(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getpurchasedAssetCatogry')
    async getpurchasedAssetCatogry(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssignedforRentCatogry(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getTop5SaleAssets')
    async getTop5SaleAssets(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getTop5SaleAssets(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
   
    @Post('/getMonthwiseAssetsSale')
    async getMonthwiseAssetsSale(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getMonthwiseAssetsSale(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAuditReportData')
    async getAuditReportData(@Body() req?: AssetServiceRportReq): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAuditReportData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    
    @Post('/getAssetSaleReport')
    async getAssetSaleReport(@Body() req?: AssetServiceRportReq): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssetSaleReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    
    @Post('/getVmsReportData')
    async getVmsReportData(@Body() req?: AssetServiceRportReq): Promise<CommonResponse> {
        try {
            return await this.assetsService.getVmsReportData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getServiceReport')
    async getServiceReport(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getServiceReport();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getRevenuReport')
    async getRevenuReport(): Promise<CommonResponse> {
        try {
            return await this.assetsService.getRevenuReport();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/updateChecklist')
    async updateChecklist(@Body() req?: UpdateChecklist[]): Promise<CommonResponse> {
        try {
            return await this.assetsService.updateChecklist(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getCurrentService')
    async getCurrentService(@Body() req?: AssetServiceReq): Promise<CommonResponse> {
        try {
            return await this.assetsService.getCurrentService(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAssetChecklist')
    async getAssetChecklist(@Body() req?: AssetChecklistRequestDto): Promise<CommonResponse> {
        try {
            return await this.assetsService.getAssetChecklist(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getLocationService')
    async getLocationService(@Body() req?: AssetServiceReq): Promise<CommonResponse> {
        try {
            return await this.assetsService.getLocationService(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getChecklistReport')
    async getChecklistReport(@Body() req?: AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetsService.getChecklistReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    
    @Post('/updateServiceChecklist')
    async updateServiceChecklist(@Body() req: UpdateChecklist): Promise<CommonResponse> {
        try {
            return await this.assetsService.updateServiceChecklist(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}
